export default __webpack_public_path__ + "static/N0064-297164c1eebbb3078144404ccb9ea2d2.png";